import React from 'react';

function Footer() {
  return (
    <div
      style={{
        height: '80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1rem',
      }}
    >
      <p>짤해 웹 Ver 0.1.0</p>
      <a href='https://play.google.com/store/apps/details?id=com.fobid.zzal'>
        짤해 안드로이드 앱
      </a>
      <p>
        Made by limu /<a href='https://github.com/limunosekai'>Github</a>
      </p>
      <p>contact : powerlsh0103@gmail.com</p>
    </div>
  );
}

export default Footer;
